export default function () {
  const customerCheckbox = document.querySelectorAll('#customer[type=checkbox]')[0];
  const formTextarea = document.querySelectorAll('textarea.form-control')[0];
  const customerNumberInput = document.getElementsByClassName ('form-group-customer-no')[0];

  if (customerCheckbox && customerNumberInput) {
    customerCheckbox.addEventListener('change', function (event) {
      event.preventDefault();
      if (event.target.checked) {
        customerNumberInput.classList.remove('hidden');
        formTextarea.style.height = '80px';
      } else {
        customerNumberInput.classList.add('hidden');
        formTextarea.style.height = '148px';
      }
    });
  }

  const divergentDeliveryAddressCheckbox = document.querySelectorAll('#divergent-delivery-address[type=checkbox]')[0];
  const divergentDeliveryAddressInputs = document.getElementsByClassName ('form-group-divergent-delivery-address')[0];

  if (divergentDeliveryAddressCheckbox && divergentDeliveryAddressInputs) {
    divergentDeliveryAddressCheckbox.addEventListener('change', function (event) {
      event.preventDefault();
      if (event.target.checked) {
        divergentDeliveryAddressInputs.classList.remove('hidden');
      } else {
        divergentDeliveryAddressInputs.classList.add('hidden');
      }
    });
  }

  const otherDevicesCheckbox = document.querySelectorAll('#other-devices-checkbox[type=checkbox]')[0];
  const otherDevicesInput = document.getElementsByClassName ('form-group-other-devices')[0];

  if (otherDevicesCheckbox && otherDevicesInput) {
    otherDevicesCheckbox.addEventListener('change', function (event) {
      event.preventDefault();
      if (event.target.checked) {
        otherDevicesInput.classList.remove('hidden');
      } else {
        otherDevicesInput.classList.add('hidden');
      }
    });
  }
}
